import { AutomationsPresentationV1 } from 'Automations/automationEditor'
import { presentationToConductorWorkflow } from 'Automations/nodeDefinitions/helpers/presentationToConductorWorkflow'
import { ResolvedNodeDefinitions } from 'Automations/nodeDefinitions/types'

/**
 * Whether the design can be transformed into a Conductor workflow. Generation
 * is otherwise only attempted at save time, where a throw is silently swapped
 * for our no-op placeholder — so an ungeneratable design could be published as
 * an inert workflow. The publish flow calls this to block that and surface the
 * failure to the user.
 */
export const canGenerateWorkflow = (
  presentation: AutomationsPresentationV1,
  definitions: ResolvedNodeDefinitions
): boolean => {
  try {
    presentationToConductorWorkflow({
      name: 'validating',
      description: '',
      presentation,
      definitions
    })
    return true
  } catch {
    return false
  }
}
